import { Box, styled } from '@mui/material'

export const FieldPointsContainer = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  backgroundColor: '#EAEEF2',
  padding: '16px 8px',
  gap: '8px',
  marginTop: '8px',
})
